document.addEventListener("DOMContentLoaded", () => {
 
  if (!window.sizeGuideData) return;
 
  const root        = document.getElementById("srab-root");
  const modal       = document.getElementById("srab-modal");
  const openBtn     = document.getElementById("srab-open");
  const closeBtn    = document.getElementById("srab-close");
  const backdrop    = document.getElementById("srab-backdrop");
  const step1       = document.getElementById("srab-step-1");
  const stepFit     = document.getElementById("srab-step-fit");
  const stepResult  = document.getElementById("srab-step-result");
  const segs        = document.querySelectorAll("#srab-progress .srab-seg");
  const errorMsg    = document.getElementById("srab-error");
  const isFr        = !!window.srIsFr;
 
  if (root) root.style.visibility = "visible";
    // Pages pack : pas de variante native à cliquer, on retire le bouton d'action.
  const isStandalone = !!(root && root.classList.contains("srab-standalone"));
  if (isStandalone) {
    const selBtn = document.getElementById("srab-select");
    if (selBtn) selBtn.style.display = "none";
  }
 
  let userHeight = 0;
  let userWeight = 0;
  let fitPref    = "regular";
 
  const productType = window.sizeGuideData.type || "tee";
  const isPants     = productType === "pants" || productType === "jogger";
  const isSwim      = productType === "swimshort";
 
  const baseEaseByType = { tee: 20, jacket: 26, zip: 26, pants: 7, jogger: -3, longsleeve: 20, hoodie: 16, swimshort: 16, tee_standard: 10 };
  const baseEase = window.sizeGuideData.ease ?? (baseEaseByType[productType] || 20);
 
  function estimateChest(h, w) { return Math.round(0.54 * w + 0.05 * h + 48); }
  function estimateWaist(h, w) { return Math.round(0.56 * w + 0.02 * h + 34); }
 
  // ─── Onglets ──────────────────────────────────────────────────────────────────
  const tabSize    = document.getElementById("srab-tab-size");
  const tabChart   = document.getElementById("srab-tab-chart");
  const panelSize  = document.getElementById("srab-panel-size");
  const panelChart = document.getElementById("srab-panel-chart");
 
  function showTab(which) {
    const sizeActive = which === "size";
    tabSize.classList.toggle("srab-tab-active", sizeActive);
    tabChart.classList.toggle("srab-tab-active", !sizeActive);
    panelSize.classList.toggle("srab-panel-active", sizeActive);
    panelChart.classList.toggle("srab-panel-active", !sizeActive);
  }
  tabSize.addEventListener("click", () => showTab("size"));
  tabChart.addEventListener("click", () => showTab("chart"));
 
  // ─── Open / Close ─────────────────────────────────────────────────────────────
  function openModal() {
    modal.style.display = "flex";
    setTimeout(() => modal.classList.add("srab-visible"), 10);
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("srab-locked");
  }
  function closeModal() {
    modal.classList.remove("srab-visible");
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("srab-locked");
    setTimeout(() => { modal.style.display = "none"; }, 300);
  }
  openBtn.addEventListener("click", openModal);
  closeBtn.addEventListener("click", closeModal);
  backdrop.addEventListener("click", closeModal);
 
  // ─── Navigation etapes ──────────────────────────────────────────────────────────
  function showStep(stepEl, segOn) {
    [step1, stepFit, stepResult].forEach(s => s.classList.remove("srab-active"));
    stepEl.classList.add("srab-active");
    segs.forEach((s, i) => s.classList.toggle("srab-seg-on", i < segOn));
  }
 
  // ─── Etape 1 : taille & poids ────────────────────────────────────────────────────
  document.getElementById("srab-next-1").addEventListener("click", () => {
    const h = parseInt(document.getElementById("srab-height").value);
    const w = parseInt(document.getElementById("srab-weight").value);
    if (!h || !w || h < 140 || h > 220 || w < 35 || w > 160) {
      errorMsg.classList.remove("hidden");
      return;
    }
    errorMsg.classList.add("hidden");
    userHeight = h;
    userWeight = w;
    showStep(stepFit, 2);
  });
 
  // ─── Etape 2 : coupe ────────────────────────────────────────────────────────────
  const fitBtns = document.querySelectorAll(".srab-fit-btn");
  fitBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      fitBtns.forEach(b => b.classList.remove("srab-fit-active"));
      btn.classList.add("srab-fit-active");
      fitPref = btn.dataset.fit;
    });
  });
  document.getElementById("srab-back-fit").addEventListener("click", () => showStep(step1, 1));
 
  document.getElementById("srab-result-btn").addEventListener("click", () => {
    const { recommended, scores } = calculateSize();
    document.getElementById("srab-size-badge").textContent = recommended;
 
    const fitFr = { fitted: "ajustée", regular: "regular", oversize: "oversize" };
    const fitEn = { fitted: "fitted", regular: "regular", oversize: "oversize" };
    document.getElementById("srab-fit-context").textContent = isFr
      ? "Pour une coupe " + (fitFr[fitPref] || "regular")
      : "For a " + (fitEn[fitPref] || "regular") + " fit";
    document.getElementById("srab-size-sub").textContent = userHeight + " cm · " + userWeight + " kg";
 
    renderGauge(recommended, scores);
    showStep(stepResult, 2);
  });
 
  // ─── Algorithme dedie short de bain ───────────────────────────────────────────
  // Un short de bain tient par sa ceinture elastique : la stature n'a pratiquement
  // aucune influence sur la taille a prendre, c'est la corpulence qui decide.
  // Les seuils de bascule sont deduits du tableau du produit lui-meme : la bascule
  // entre deux tailles tombe au milieu du recouvrement de leurs plages de poids
  // (ex. M 60-75 et L 70-88 se recouvrent sur 70-75 -> bascule a 72,5 kg), puis on
  // recale legerement selon la stature (a corpulence egale, +1 cm ~ +0,36 kg).
  // La cle "waist" du metachamp n'est pas utilisee (vestige de l'ancienne etape 3).
  function calculateSizeSwim() {
    const sizes = window.sizeGuideData.sizes || window.sizeGuideData;
    const order = ["XS", "S", "M", "L", "XL", "XXL"].filter(s => sizes[s]);
    if (!order.length) return { recommended: "M", scores: {} };
 
    // La preference de coupe decale d'au plus un cran.
    const fitShift = { fitted: -4, regular: 0, oversize: 4 };
    const w = userWeight + (fitShift[fitPref] || 0);
 
    // Seuils de bascule, en kg, ajustes a la stature du client.
    const thresholds = [];
    for (let i = 0; i < order.length - 1; i++) {
      const a = sizes[order[i]], b = sizes[order[i + 1]];
      const refWeight = (a.maxWeight + b.minWeight) / 2;
      const refHeight = (a.maxHeight + b.minHeight) / 2;
      const adjust    = Math.max(-6, Math.min(6, (userHeight - refHeight) * 0.36));
      thresholds.push(refWeight + adjust);
    }
 
    let i = 0;
    while (i < thresholds.length && w >= thresholds[i]) i++;
    const recommended = order[i];
 
    // Scores pour la jauge : la taille voisine monte a mesure qu'on approche du seuil.
    const scores = {};
    order.forEach(s => { scores[s] = 0; });
    const lo = i > 0 ? thresholds[i - 1] : thresholds[0] - 12;
    const hi = i < thresholds.length ? thresholds[i] : thresholds[thresholds.length - 1] + 12;
    const p  = Math.max(0, Math.min(1, (w - lo) / (hi - lo)));
    scores[recommended] = 100;
    if (order[i + 1]) scores[order[i + 1]] = Math.round(80 * p);
    if (order[i - 1]) scores[order[i - 1]] = Math.round(80 * (1 - p));
 
    return { recommended, scores };
  }
 
  // ─── Algorithme (mesure corporelle estimee depuis taille + poids) ──────────────────
  function calculateSize() {
    if (isSwim) return calculateSizeSwim();
 
    const sizes      = window.sizeGuideData.sizes || window.sizeGuideData;
    const order      = ["XS", "S", "M", "L", "XL", "XXL"];
    const measureKey = isPants ? "waist" : "chest";
    const corpo      = isPants ? estimateWaist(userHeight, userWeight) : estimateChest(userHeight, userWeight);
 
    const easeMap = { fitted: baseEase - 8, regular: baseEase, oversize: baseEase + 8 };
    const target  = corpo + (easeMap[fitPref] || baseEase);
 
    const weightOffset  = { fitted: -10, regular: 0, oversize: 10 };
    const scoringWeight = userWeight + (weightOffset[fitPref] || 0);
 
    let scores = {};
    order.forEach(s => { scores[s] = 0; });
 
    // Signal A : hauteur (10 pts)
    let heightMatched = false;
    for (const size of order) {
      const s = sizes[size];
      if (!s) continue;
      if (userHeight >= s.minHeight && userHeight <= s.maxHeight) {
        scores[size] += 10;
        heightMatched = true;
      }
    }
    if (!heightMatched) {
      let best = "M", bestDiff = Infinity;
      for (const size of order) {
        const s = sizes[size];
        if (!s) continue;
        const diff = Math.abs(userHeight - (s.minHeight + s.maxHeight) / 2);
        if (diff < bestDiff) { bestDiff = diff; best = size; }
      }
      scores[best] += 10;
    }
 
    // Contrainte dure hauteur max
    for (const size of order) {
      const s = sizes[size];
      if (s && s.maxHeight && userHeight > s.maxHeight + 2) scores[size] = -999;
    }
 
    // Signal B : poids avec offset fit (5 pts)
    let weightMatched = false;
    for (const size of order) {
      const s = sizes[size];
      if (!s || scores[size] === -999) continue;
      if (scoringWeight >= s.minWeight && scoringWeight <= s.maxWeight) {
        scores[size] += 5;
        weightMatched = true;
      }
    }
    if (!weightMatched) {
      let best = "M", bestDiff = Infinity;
      for (const size of order) {
        const s = sizes[size];
        if (!s || scores[size] === -999) continue;
        const diff = Math.abs(scoringWeight - (s.minWeight + s.maxWeight) / 2);
        if (diff < bestDiff) { bestDiff = diff; best = size; }
      }
      scores[best] += 5;
    }
 
    // Signal C : mesure vetement (14 pts — signal principal)
    {
      let best = null, bestDiff = Infinity;
      for (const size of order) {
        const s = sizes[size];
        if (!s || scores[size] === -999 || !s[measureKey]) continue;
        const diff = Math.abs(s[measureKey] - target);
        if (diff < bestDiff) { bestDiff = diff; best = size; }
      }
      if (best) {
        scores[best] += 14;
        const idx = order.indexOf(best);
        if (idx > 0 && scores[order[idx - 1]] !== -999) scores[order[idx - 1]] += 2;
        if (idx < order.length - 1 && scores[order[idx + 1]] !== -999) scores[order[idx + 1]] += 2;
      }
    }
 
    // Penalites fit
    if (fitPref === "fitted")   ["L", "XL", "XXL"].forEach(sz => { if (scores[sz] > -999) scores[sz] -= 8; });
    if (fitPref === "oversize") ["XS", "S"].forEach(sz         => { if (scores[sz] > -999) scores[sz] -= 8; });
 
    // Gagnant
    let recommended = "M", maxScore = -Infinity;
    for (const size of order) {
      if (!sizes[size]) continue;
      if ((scores[size] || 0) > maxScore) { maxScore = scores[size]; recommended = size; }
    }
 
    return { recommended, scores };
  }
 
  // ─── Jauge ────────────────────────────────────────────────────────────────────
  function renderGauge(recommended, scores) {
    const sizes     = window.sizeGuideData.sizes || window.sizeGuideData;
    const order     = ["XS", "S", "M", "L", "XL", "XXL"];
    const available = order.filter(s => sizes[s] && (scores[s] || 0) > -999);
    const idx       = available.indexOf(recommended);
    if (idx === -1) return;
 
    const start        = Math.max(0, Math.min(idx - 1, available.length - 3));
    const visible      = available.slice(start, start + 3);
    const posInVisible = visible.indexOf(recommended);
    const prevSize     = visible[posInVisible - 1];
    const nextSize     = visible[posInVisible + 1];
    const recScore     = Math.max(scores[recommended] || 1, 1);
    const prevScore    = prevSize ? Math.max(scores[prevSize] || 0, 0) : 0;
    const nextScore    = nextSize ? Math.max(scores[nextSize] || 0, 0) : 0;
 
    const slotWidth = 100 / visible.length;
    let pct = (posInVisible + 0.5) * slotWidth;
    if (nextScore > 0) pct += slotWidth * Math.min((nextScore / recScore) * 0.4, 0.4);
    if (prevScore > 0) pct -= slotWidth * Math.min((prevScore / recScore) * 0.4, 0.4);
    pct = Math.max(5, Math.min(95, pct));
 
    const labelsEl = document.getElementById("srab-gauge-labels");
    labelsEl.innerHTML = "";
    visible.forEach(size => {
      const el = document.createElement("span");
      el.className   = "srab-gauge-label" + (size === recommended ? " srab-gauge-active" : " srab-gauge-secondary");
      el.textContent = size;
      labelsEl.appendChild(el);
    });
 
    document.querySelector("#srab-gauge-hints span:first-child").classList.toggle("srab-hint-visible", !!prevSize);
    document.querySelector("#srab-gauge-hints span:last-child").classList.toggle("srab-hint-visible", !!nextSize);
    document.getElementById("srab-gauge-cursor").style.left = pct + "%";
  }
 
  // ─── Selectionner la taille ───────────────────────────────────────────────────
  document.getElementById("srab-select").addEventListener("click", () => {
    const size = document.getElementById("srab-size-badge").textContent;
    document.querySelectorAll('.product__form [data-value], .variant-buttons [data-value], input[type="radio"][value]').forEach(btn => {
      const val = btn.dataset.value || btn.value || btn.textContent.trim();
      if (val.toUpperCase() === size.toUpperCase()) btn.click();
    });
    closeModal();
  });
 
  // ─── Recommencer ──────────────────────────────────────────────────────────────
  document.getElementById("srab-restart").addEventListener("click", () => {
    ["srab-height", "srab-weight"].forEach(id => { document.getElementById(id).value = ""; });
    fitBtns.forEach(b => b.classList.remove("srab-fit-active"));
    document.querySelector('.srab-fit-btn[data-fit="regular"]').classList.add("srab-fit-active");
    fitPref = "regular";
    userHeight = userWeight = 0;
    showStep(step1, 1);
  });
 
});
 